import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AutonomyLevelPipe } from './autonomy-level.pipe';

const PIPES = [AutonomyLevelPipe];

@NgModule({
  imports: [CommonModule],
  declarations: [PIPES],
  exports: [PIPES],
})
export class AiAssistantPipesModule {}
